var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOutFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7775 34.2C17.7775 35.1954 16.9811 36 15.9998 36H8.88876C3.9875 36 0 31.9626 0 27V9C0 4.0374 3.9875 0 8.88876 0H15.9998C16.9811 0 17.7775 0.8046 17.7775 1.8C17.7775 2.7954 16.9811 3.6 15.9998 3.6H8.88876C5.94836 3.6 3.55551 6.0228 3.55551 9V27C3.55551 29.9772 5.94836 32.4 8.88876 32.4H15.9998C16.9829 32.4 17.7775 33.2046 17.7775 34.2ZM31.4787 16.7273L24.3677 9.52734C23.6726 8.82354 22.549 8.82354 21.8539 9.52734C21.1588 10.2311 21.1588 11.3689 21.8539 12.0727L25.9303 16.2H12.4443C11.463 16.2 10.6665 17.0046 10.6665 18C10.6665 18.9954 11.463 19.8 12.4443 19.8H25.9303L21.8539 23.9273C21.1588 24.6311 21.1588 25.7689 21.8539 26.4727C22.2006 26.8237 22.6557 27 23.1108 27C23.5659 27 24.021 26.8237 24.3677 26.4727L31.4787 19.2727C32.1738 18.5689 32.1738 17.4293 31.4787 16.7273Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutFilled);
export default __webpack_public_path__ + "static/media/log-out-Filled.dbcabbe21d2c626e048576c3382a7d27.svg";
export { ForwardRef as ReactComponent };